import { fromEvent } from 'rxjs';
import ControllerBase from '../../../../global/js/ControllerBase';
import { FormstepSystemComponentEvents } from './m-formstep-system-component.events';

type ComponentRefs = {
    componentRemovalButton: 'form-slice-deleter';
    componentSubmitButton: 'form-slice-submit';
    exitEditModeButton: 'form-slice-exit-edit-mode';
    serialNumberInput: 'm-formstep-system-component__serialNumber';
    shortDescriptionInput: 'm-formstep-system-component__shortDescription'
};

export default class ControllerSystemComponent extends ControllerBase<ComponentRefs> {
    removalButton: HTMLButtonElement
    submitButton: HTMLElement
    exitEditModeButton: HTMLElement
    serialNumberInput: HTMLInputElement
    shortDescriptionInput: HTMLInputElement

    private static readonly componentRefs: ComponentRefs = {
        componentRemovalButton: 'form-slice-deleter',
        componentSubmitButton: 'form-slice-submit',
        exitEditModeButton: 'form-slice-exit-edit-mode',
        serialNumberInput: 'm-formstep-system-component__serialNumber',
        shortDescriptionInput: 'm-formstep-system-component__shortDescription'
    };

    constructor(element: HTMLElement) {
        super(element, [], Object.values(ControllerSystemComponent.componentRefs));
        this.removalButton = this.$references[ControllerSystemComponent.componentRefs.componentRemovalButton]
        this.exitEditModeButton = this.$references[ControllerSystemComponent.componentRefs.exitEditModeButton]
        this.submitButton = this.$references[ControllerSystemComponent.componentRefs.componentSubmitButton]
        this.serialNumberInput = this.$references[ControllerSystemComponent.componentRefs.serialNumberInput]
        this.shortDescriptionInput = this.$references[ControllerSystemComponent.componentRefs.shortDescriptionInput]
        this.initApp()
    }

    observeShortDescriptionSubmission(): void {
        this.inputUtils.observeElementEvents(this.shortDescriptionInput, 'input', (value) => {
            if (value) {
                this.submitButton.classList.remove('input-disabled')
            } else this.submitButton.classList.add('input-disabled')
        })
    }

    observeExitEditModeRequest(): void {
        const click$ = fromEvent(this.exitEditModeButton, 'click');

        click$.subscribe((e: Event | MouseEvent) => {
			e.preventDefault();
            this.requestExitEditMode();
        });
    }

    observeSubmitFormPartRequest(): void {
        const click$ = fromEvent(this.submitButton, 'click');

        click$.subscribe((e: Event | MouseEvent) => {
			e.preventDefault();
            this.requestSubmitSystemComponent();

        });
    }

    observeRemoveFormPartRequest(): void {
        const click$ = fromEvent(this.removalButton, 'click');

        click$.subscribe((e: Event | MouseEvent) => {
			e.preventDefault();
            this.removeFormPartFromDom();

        });
    }

    requestSubmitSystemComponent(): void {
        const elementId = this.$element.id
        this.dispatchCustomEvent(FormstepSystemComponentEvents.REQUEST_ADD_SYSTEM_COMPONENT, { elementId }, true, true)
    }

    requestExitEditMode(): void {
        const elementId = this.$element.id
        this.dispatchCustomEvent(FormstepSystemComponentEvents.EXIT_EDIT_MODE, { elementId }, true, true)
    }


    removeFormPartFromDom(): void {
        const elementId = this.$element.id
        this.dispatchCustomEvent(FormstepSystemComponentEvents.REMOVE_SYSTEM_COMPONENT, { elementId }, true, true)
        this.$element.remove()
    }

    initApp(): void {
        this.observeRemoveFormPartRequest()
        this.observeSubmitFormPartRequest()
        this.observeExitEditModeRequest()
        this.observeShortDescriptionSubmission()
    }

}
